import { Pipe, PipeTransform } from '@angular/core';
import { QrCodeData } from '@cue/data';

@Pipe({
  name: 'poiBoolean',
  standalone: true,
})
export class PoiBooleanFilterPipe implements PipeTransform {
  transform(qrCodeList: QrCodeData[], boolPropertyName: string): QrCodeData[] {
    if (qrCodeList.length > 0 && qrCodeList[0][boolPropertyName] == null) {
      return qrCodeList;
    }
    return qrCodeList.filter((x) => x[boolPropertyName] == true);
  }
}
